var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// eslint-disable-next-line no-unused-vars
import { useContext, useMemo, useRef } from 'react';
import { ThemeContext } from '@cvent/carina-theme-provider';
import { getStyle } from './iconGetStyle';
// These icons are here and not there because of the complexity.
// These are both animated as well as all of them having multiple colours.
export var LoadingIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'm' : _b, id = _a.id;
    var style = __assign({}, useStyle(size));
    var keyCount = 1;
    function getKey() {
        if (keyCount < Number.MAX_SAFE_INTEGER - 1) {
            return keyCount++;
        }
        return (keyCount = 1);
    }
    // it has to be like this to pass the tests, since the buttons and textboxes don't pass an id prop to the icon, meaning if I randomly generated an id, it would be different each test, meaning that they would always fail
    var strokeId = useRef(id || getKey());
    // each circle needs its own unique id so it does not interfere with other ones, if they are on the same page
    // making it like this probably isn't the best way of doing it, but it is something that works and lets me get back to other things in the mean time
    return (_jsx("div", __assign({ css: style.outerContainerStyle }, { children: _jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", css: style.circleStyle, fill: "transparent" }, { children: [_jsx("defs", { children: _jsxs("linearGradient", __assign({ id: strokeId.current.toString() }, { children: [_jsx("stop", { offset: "0%", stopColor: style.gradientColor1 }, void 0),
                            _jsx("stop", { offset: "50%", stopColor: style.gradientColor2 }, void 0),
                            _jsx("stop", { offset: "100%", stopColor: style.gradientColor3 }, void 0)] }), void 0) }, void 0),
                _jsx("circle", { cx: "50%", cy: "50%", r: '45%', stroke: style.rail, strokeLinecap: "round", fill: "transparent" }, void 0),
                _jsx("circle", { stroke: "url(#" + strokeId.current + ")", cx: "50%", cy: "50%", r: '45%', css: __assign({}, style.tailChaserStyle) }, void 0)] }), void 0) }), void 0));
};
function useStyle(size) {
    var theme = useContext(ThemeContext);
    var _a = useMemo(function () { return getStyle(theme); }, [theme]), outerContainer = _a.outerContainer, circle = _a.circle, tailChaser = _a.tailChaser, 
    // these are features to be released later
    // dangerColors,
    // primaryColors,
    // accentColors,
    // successColors,
    // tertiaryColors,
    // warningColors,
    defaultColors = _a.defaultColors;
    return {
        outerContainerStyle: __assign({}, outerContainer.base),
        circleStyle: __assign(__assign(__assign(__assign(__assign({}, circle.base), (size === 'xl' ? circle.xl : {})), (size === 'l' ? circle.l : {})), (size === 'm' ? circle.m : {})), (size === 's' ? circle.s : {})),
        tailChaserStyle: __assign(__assign(__assign(__assign(__assign({}, tailChaser.base), (size === 'xl' ? tailChaser.xl : {})), (size === 'l' ? tailChaser.l : {})), (size === 'm' ? tailChaser.m : {})), (size === 's' ? tailChaser.s : {})),
        gradientColor1: defaultColors.gradientColor1,
        gradientColor2: defaultColors.gradientColor2,
        gradientColor3: defaultColors.gradientColor3,
        rail: defaultColors.rail
        // when variants are ready, uncomment and add back to props
        // ...(variant === 'danger'
        //   ? {
        //       gradientColor1: dangerColors.gradientColor1,
        //       gradientColor2: dangerColors.gradientColor2,
        //       gradientColor3: dangerColors.gradientColor3,
        //       rail: dangerColors.rail
        //     }
        //   : {}),
        // ...(variant === 'primary'
        //   ? {
        //       gradientColor1: primaryColors.gradientColor1,
        //       gradientColor2: primaryColors.gradientColor2,
        //       gradientColor3: primaryColors.gradientColor3,
        //       rail: primaryColors.rail
        //     }
        //   : {}),
        // ...(variant === 'accent'
        //   ? {
        //       gradientColor1: accentColors.gradientColor1,
        //       gradientColor2: accentColors.gradientColor2,
        //       gradientColor3: accentColors.gradientColor3,
        //       rail: accentColors.rail
        //     }
        //   : {}),
        // ...(variant === 'success'
        //   ? {
        //       gradientColor1: successColors.gradientColor1,
        //       gradientColor2: successColors.gradientColor2,
        //       gradientColor3: successColors.gradientColor3,
        //       rail: successColors.rail
        //     }
        //   : {}),
        // ...(variant === 'tertiary'
        //   ? {
        //       gradientColor1: tertiaryColors.gradientColor1,
        //       gradientColor2: tertiaryColors.gradientColor2,
        //       gradientColor3: tertiaryColors.gradientColor3,
        //       rail: tertiaryColors.rail
        //     }
        //   : {}),
        // ...(variant === 'warning'
        //   ? {
        //       gradientColor1: warningColors.gradientColor1,
        //       gradientColor2: warningColors.gradientColor2,
        //       gradientColor3: warningColors.gradientColor3,
        //       rail: warningColors.rail
        //     }
        //   : {})
    };
}
